import reqDoublePoin from '@/src/requests/double-poin'

export const funcGetOnePromoDoublePoin = async (resource, params) => {
  const data = await reqDoublePoin.getOne(params.id)
  return { data }
}
